import { render, staticRenderFns } from "./CPageTitle.vue?vue&type=template&id=4dbad0d3&scoped=true&"
import script from "./CPageTitle.vue?vue&type=script&lang=js&"
export * from "./CPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./CPageTitle.vue?vue&type=style&index=0&id=4dbad0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbad0d3",
  null
  
)

export default component.exports